<button matTooltip="{{ alt }}" [ngClass]="btnType" [tabindex]="tabIndex" class="{{colorClass}}">
  <ng-container *ngIf="iconPath; else materialIcon">
    <img src="{{ iconPath }}" [ngClass]="sizeClass" alt="{{ alt }}" />
  </ng-container>
  <ng-template #materialIcon>
    <mat-icon [ngClass]="sizeClass" [attr.alt]="alt">{{
      icon
      }}</mat-icon>
    <span class="cdk-visually-hidden" title="{{ alt }}"></span>
  </ng-template>
</button>
